import { defineCustomElement } from 'vue'

// Automatically register all Vue components located within the /src/components folder.
const requireComponent = import.meta.glob(
  // The regular expression pattern for matching component filenames
  "./components/**/[A-Z]*.{vue,js}",
  { eager: true }
);

Object.entries(requireComponent).forEach(([fileName, componentConfig]) => {
  if (fileName === undefined) return;

  // Get PascalCase name of a component
  const componentName =  fileName
    .split("/")
    .pop()
    .replace(/\.\w+$/, "");

  // https://vuejs.org/api/custom-elements
  // Look for the component options on `.default`, which will
  // exist if the component was exported with `export default`,
  // otherwise fall back to module's root.
  customElements.define(pascalToKebabCase(componentName), defineCustomElement(componentConfig.default || componentConfig, { shadowRoot: false }))
});

/**
 * convert PascalCase to kebab-case
 * @param str
 * @link https://dev.to/mattkenefick/snippets-in-javascript-converting-pascalcase-to-kebab-case-36ed
 */
function pascalToKebabCase(str: string): string {
  return str.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase()
}